<template>
    <div>
        <template v-for="modal in activeModals" :key="modal.name">
            <component :is="modal.component" v-bind="modal.props" />
        </template>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { useModal } from '@/composables/useModal'

const { getActiveModals, closeModal } = useModal()

const activeModals = computed(() => getActiveModals())
</script>